import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, InputAdornment, InputBase, Paper, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { useParams } from 'react-router-dom';
import { actualizarTarea, deleteDesplazamientoTarea, deleteExtraTarea, getDesplazamientosTarea, getExtrasTarea, getOpcionesCrearTareas, getProyectos, getUsuariosCliente } from '../../../services/apis';
import AutocompleteList from '../../../utils/componentes-utiles/AutocompleteList';
import { formatMinutosHoras, ordenarOpcionesPorLabel, textoMayusculas } from '../../../utils/utils';
import TimeCounter from '../../../utils/componentes-utiles/TimeCounter';
import { AlertError } from '../../../utils/componentes-utiles/AlertError';
import { SelectorRoles } from './SelectorRoles';
import { ArticulosExtra } from '../../taller/ArticulosExtra';
import { DesplazamientosTarea } from './DesplazamientosTarea';

export const FormEditarTarea = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores, trabajadores, opcionesTipoTareas, opProyectosPreCargados = [] }) => {
    const proyectoModificadoPorUsuario = useRef(false);

    const handleClose = () => {
        setOpen(false);
    };

    const parseStringToArray = (input) => {
        console.log('isArray?', Array.isArray(input), 'value:', input);

        if (Array.isArray(input)) {
            return input.map(Number).filter(n => !isNaN(n));
        }

        if (typeof input !== 'string') {
            return [];
        }

        try {
            return input
                .trim()
                .replace(/^\s*\[|\]\s*$/g, '') // elimina corchetes con espacios
                .split(',')
                .map(s => Number(s.trim()))
                .filter(n => !isNaN(n));
        } catch (e) {
            console.error('Error parsing input:', e);
            return [];
        }
    };

    const param = useParams();
    const obtenerProyectoInicial = (opcionesProyectos = opProyectosPreCargados) => {
        const proyectoEncontrado = opcionesProyectos.find(
            (opcion) => String(opcion.value) === String(tareaInfo.id_proyecto)
        );
        const nombreProyecto = Array.isArray(tareaInfo.nombre_proyecto)
            ? (tareaInfo.nombre_proyecto[0]?.label || tareaInfo.nombre_proyecto[0]?.nombre || '')
            : tareaInfo.nombre_proyecto;

        return proyectoEncontrado || {
            label: nombreProyecto || 'Seleccione un Proyecto',
            value: tareaInfo.id_proyecto || "0"
        };
    };
    // Estados locales para los campos del formularioF

    const [tarea, setTarea] = useState(tareaInfo)

    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState({ label: "Aginar a un Trabajador", value: "0" });
    const [time, setTime] = useState(0);
    const [tiempoEstimado, setTiempoEstimado] = useState(Number(tareaInfo.minutos_estimados || 0));
    const [usuarioSelec, setUsuarioSelec] = useState({ label: "Seleccione un Usuario", value: "0" });
    const [opUsuarios, setOpUsuarios] = useState([]);
    const [opProyectos, setOpProyectos] = useState(opProyectosPreCargados);
    const [proyectosCargados, setProyectosCargados] = useState(opProyectosPreCargados.length > 0);
    const [proyectos, setProyectos] = useState([]);
    const [opciones, setOpciones] = useState([]);
    const [oculto, setOculto] = useState(false);
    const [proyectoSelec, setProyectoSelec] = useState(obtenerProyectoInicial);
    const [tipoTarea, setTipoTarea] = useState({ label: 'Sin Tipo', value: "0" });
    const [roles, setRoles] = useState([])
    const [rolSelect, setRolSelect] = useState(parseStringToArray(tareaInfo.roles_permitidos));
    const [extras, setExtras] = useState([]);
    const [nuevoExtra, setNuevoExtra] = useState({
        descripcion: '',
        precio: null
    });
    const [desplazamientos, setDesplazamientos] = useState([]);
    const [nuevoDesplazamiento, setNuevoDesplazamiento] = useState({
        comentario: '',
        cantidad: 1
    });




    const opcionesOcultas = {
        SelectorRoles: <SelectorRoles roles={roles} setRoles={setRoles} rolSelect={rolSelect} setRolSelect={setRolSelect}></SelectorRoles>,
    };


    const handleChange = (event) => {
        if (event.target.name === "minutos") {

            let temp = formatMinutosHoras(event.target.value);
            console.log(temp);

            // const tareaNueva = { ...tarea, [event.target.name]: temp };

        } else if (event.target.name === "horas") {
            let value = parseInt(event.target.value, 10);

            if (value >= 0) {
                // No hay límite máximo para horas
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            } else {
                // Aseguramos que no sea negativo, ajustando a 0 si lo es.
                value = 0;
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            }
        } else {
            const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
            setTarea(tareaNueva);
        }
    };

    const cargarOpciones = async () => {
        try {
            const response = await getOpcionesCrearTareas();
            console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA", response);

            if (response.success) {
                setOpciones(response.data)
                setRoles(response.roles)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const cargarExtras = async (idTarea) => {
        try {
            const response = await getExtrasTarea(idTarea);

            if (response?.success) {
                setExtras(response.data)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    const cargarDesplazamientos = async (idTarea) => {
        try {
            const response = await getDesplazamientosTarea(idTarea);

            if (response?.success) {
                setDesplazamientos(response.data)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }


    useEffect(() => {
        let clienteSeleccionado = opclientes.filter(opcion => tareaInfo.id_cliente == opcion.value);
        setClienteSelec(clienteSeleccionado[0]);
        if (opProyectosPreCargados.length > 0) {
            setOpProyectos(opProyectosPreCargados);
            setProyectoSelec(obtenerProyectoInicial(opProyectosPreCargados));
            setProyectosCargados(true);
        }
        cargarProyectos();
        cargarOpciones();
        cargarExtras(tareaInfo.id);
        cargarDesplazamientos(tareaInfo.id);
    }, [])

    useEffect(() => {
        const tareaNueva = { ...tarea, ['minutos']: time };
        console.log(time);

        setTarea(tareaNueva);
    }, [time])


    // Función para manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí se puede manejar el envío de los datos (ejemplo: llamada a una API o validación)
        // Cierra el formulario
        editarTarea();
    };

    const editarTarea = async () => {
        console.log("hi");

        const nuevaTareaTmp = { ...tarea };
        console.log(clienteSelec);

        nuevaTareaTmp.id_cliente = clienteSelec ? clienteSelec.value : "0";
        nuevaTareaTmp.id_usuario = usuarioSelec ? usuarioSelec.value : "0";
        nuevaTareaTmp.id_proyecto = proyectoSelec?.value ?? tareaInfo.id_proyecto ?? "0";
        nuevaTareaTmp.trabajadores = trabajadorSelec;
        nuevaTareaTmp.tipo_tarea = tipoTarea.value;
        nuevaTareaTmp.roles_permitidos = rolSelect;
        nuevaTareaTmp.extras = extras;
        nuevaTareaTmp.desplazamientos = desplazamientos;
        nuevaTareaTmp.minutos_estimados = tiempoEstimado > 0 ? tiempoEstimado : '';

        const cambiaAEstadoFinalizadoOValidado =
            Number(tareaInfo.id_estado) < 3 && Number(nuevaTareaTmp.id_estado) >= 3;

        if (cambiaAEstadoFinalizadoOValidado && nuevaTareaTmp.minutos < 15) {
            setErrorAlert(true);
            return;
        }
        try {
            const response = await actualizarTarea(nuevaTareaTmp);
            console.log(response);

            if (response.success == true) {
                cargarTareas();
                setTarea({
                    'fecha': new Date(),
                    'asunto': null,
                    'descripcion': null,
                    'localizacion': null,
                    'id_cliente': null,
                    'id_usuario': null,
                    'minutos': null,
                    'minutos_estimados': '',
                    'horas': null,
                    'id_proyecto': param.id
                })
                setTiempoEstimado(0);
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" })
                handleClose();

            }


        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    const cargarUsuarios = async (id) => {
        console.log("Cargando usuarios para cliente ID:", id);

        try {
            const response = await getUsuariosCliente(id);
            const newTmp = ordenarOpcionesPorLabel(response.data.map(item => ({
                label: textoMayusculas(item.nombre),
                value: item.id
            })));

            setOpUsuarios(newTmp);

            // Encuentra el usuario correcto en la nueva lista en lugar de `opUsuarios`
            const usuarioSeleccionado = newTmp.find(opcion => opcion.value === tareaInfo.id_usuarioCliente);

            console.log("Usuario seleccionado:", usuarioSeleccionado);

            // Establece el usuario seleccionado (si existe)
            setUsuarioSelec(usuarioSeleccionado || { label: "Seleccione un Usuario", value: "0" });

        } catch (error) {
            console.error("Error al cargar usuarios", error);
        }
    };

    const cargarProyectos = async () => {
        try {
            setProyectosCargados(false);
            const response = await getProyectos();
            setProyectos(response.data);
            iterarProyectos(response.data);
            setProyectosCargados(true);

        } catch (error) {
            console.error("Error cargar tareas", error)
            setProyectosCargados(true);
        }
    }
    const iterarProyectos = (data) => {
        try {
            const tmp = [...data];
            const newTmp = ordenarOpcionesPorLabel([
                // Proyecto por defecto
                ...tmp.map((item) => ({
                    label: textoMayusculas(item.nombre),
                    value: item.id
                }))
            ]);
            setOpProyectos(newTmp);
            console.log("Proyectos:", newTmp);
            const proyectoSeleccionado = newTmp.find(opcion => String(tareaInfo.id_proyecto) === String(opcion.value));
            console.log("Proyecto seleccionado:", proyectoSeleccionado);

            if (!proyectoModificadoPorUsuario.current) {
                setProyectoSelec(proyectoSeleccionado || obtenerProyectoInicial(newTmp));
            }
        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }
    useEffect(() => {
        if (clienteSelec && clienteSelec.value && clienteSelec.value !== "0") {
            cargarUsuarios(clienteSelec.value);
        }
    }, [clienteSelec]);
    useEffect(() => {
        if (tareaInfo && opcionesTipoTareas) {
            const tipoSeleccionado = opcionesTipoTareas.find(tipo => tipo.value === tareaInfo.id_tipo_tarea);
            setTipoTarea(tipoSeleccionado || { label: 'Sin Tipo', value: "0" });
        }
    }, [tareaInfo, opcionesTipoTareas]);

    useEffect(() => {
        if (open) {
            proyectoModificadoPorUsuario.current = false;
            setProyectoSelec(obtenerProyectoInicial(opProyectos));

            if (!opProyectos.length) {
                cargarProyectos();
            }
        }
    }, [open, tareaInfo.id_proyecto]);

    return (
        <Dialog
            open={open}
            fullWidth
            width="md"
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
        >
            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                    sx={{ mb: 3 }}
                >
                    <Typography variant="h6">
                        Editar Tarea
                    </Typography>

                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </Grid>

                <form onSubmit={handleSubmit} style={{ minWidth: '100%' }}>
                    <Grid container xs={12} spacing={2} direction="column">
                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                name="Cliente"
                                options={opclientes}
                                value={clienteSelec}
                                onChange={(event, newValue) => {
                                    setClienteSelec(newValue);
                                }}
                                renderInput={(params) => <TextField {...params} label="Cliente*" />}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opUsuarios ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-usuario"
                                options={opUsuarios}
                                value={usuarioSelec}
                                onChange={(event, newValue) => setUsuarioSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Autocomplete
                                fullWidth
                                className={opProyectos ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-proyecto"
                                name="Proyecto"
                                options={opProyectos}
                                value={proyectoSelec}
                                loading={!proyectosCargados}
                                getOptionLabel={(option) => option?.label || ''}
                                isOptionEqualToValue={(option, value) => String(option?.value) === String(value?.value)}
                                onChange={(event, newValue) => {
                                    proyectoModificadoPorUsuario.current = true;
                                    setProyectoSelec(newValue || obtenerProyectoInicial(opProyectos));
                                }}
                                renderInput={(params) => <TextField {...params} label="Proyecto*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            Asignar:
                            <AutocompleteList array={opTrabajadores} arrayPre={trabajadores} setArray={setTrabajadorSelec}></AutocompleteList>
                        </Grid>
                        <Grid item>
                            <Autocomplete
                                fullWidth
                                className={opcionesTipoTareas ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opcionesTipoTareas}
                                value={tipoTarea}
                                onChange={(event, newValue) => setTipoTarea(newValue || { label: 'Sin Tipo', value: "0" })}
                                renderInput={(params) => <TextField {...params} label="Tipo Tarea*" />}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        xs={11.7}
                    >
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="center"
                            xs={12}
                            gap={2}
                            sx={{ mt: 2 }}
                        >
                            <Grid
                                container
                                item
                                xs={12}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                gap={1}
                                sx={{ mt: 1 }}
                            >
                                <Grid item xs={12} md={5.7}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 500,
                                            textAlign: 'start'
                                        }}
                                    >
                                        Añadir horas
                                    </Typography>

                                    <TimeCounter
                                        time={time}
                                        setTime={setTime}
                                        tiempo={tarea.horas_totales}
                                        label=""
                                    />
                                </Grid>

                                <Divider
                                    orientation="vertical"
                                    flexItem
                                    sx={{
                                        display: { xs: 'none', md: 'block' },
                                        borderColor: '#000',
                                        opacity: 0.45,
                                    }}
                                />

                                <Divider
                                    sx={{
                                        display: { xs: 'block', md: 'none' },
                                        width: '100%',
                                        borderColor: '#000',
                                        opacity: 0.45,
                                    }}
                                />

                                <Grid item xs={12} md={5.7}>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 500,
                                            textAlign: 'start'
                                        }}
                                    >
                                        Horas estimadas
                                    </Typography>

                                    <TimeCounter
                                        time={tiempoEstimado}
                                        setTime={setTiempoEstimado}
                                        tiempo={0}
                                        label=""
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12}>
                            <ArticulosExtra
                                extras={extras}
                                setExtras={setExtras}
                                nuevoExtra={nuevoExtra}
                                setNuevoExtra={setNuevoExtra}
                                idTarea={tarea.id}
                                deleteExtraApi={deleteExtraTarea}
                                borrarLocalmente
                                compacto
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <DesplazamientosTarea
                                desplazamientos={desplazamientos}
                                setDesplazamientos={setDesplazamientos}
                                nuevoDesplazamiento={nuevoDesplazamiento}
                                setNuevoDesplazamiento={setNuevoDesplazamiento}
                                idTarea={tarea.id}
                                deleteDesplazamientoApi={deleteDesplazamientoTarea}
                            />
                        </Grid>

                        {opciones[0] && (
                            <Grid item xs={12} sx={{ mt: 2 }}>
                                {opcionesOcultas[opciones[0].nombre]}
                            </Grid>
                        )}
                    </Grid>
                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Editar Tarea
                </Button>
            </DialogActions>
            {
                errorAlert && (
                    <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Minimo 15 minutos de trabajo"} />
                )

            }
        </Dialog>

    );
};
